module.exports = require("immutable");


//////////////////
// WEBPACK FOOTER
// external "immutable"
// module id = 367
// module chunks = 0